import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DefaultButton, TextField, MessageBar, MessageBarType } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  stepTwo: ({ isMobile } = {}) => ({
    padding: isMobile ? '0 23px' : '0 72px',

    '& .preview-warning-message': {
      marginTop: 8,
    },
  }),
  bold: {
    fontWeight: 600,
  },
  form: {
    marginTop: 20,

    '& .ms-TextField-fieldGroup': {
      border: '1px solid #B3B0AD',
    },

    '& .name': {
      display: 'flex',
      justifyContent: 'space-between',

      '& .ms-TextField': {
        width: 202,
      },
    },
  },
  item: {
    minHeight: 80,
  },
  error: {
    color: 'red',
  },
});

const editButtonStyle = {
  root: {
    minWidth: 60,
    marginLeft: 20,
    height: 26,
  },
};

const textAreaStyle = {
  fieldGroup: {
    height: 134,
  },
};

const UnstyledBookingStepUserInfo = ({
  classes,
  className,
  i18n,
  bookingTimeInfo,
  onEditTime,
  name,
  onChangeName,
  email,
  onChangeEmail,
  phoneNumber,
  onChangePhoneNumber,
  extraMessage,
  errorMessage,
  onChangeExtraMessage,
  showWarning,
}) => (
  <div className={classNames(classes.stepTwo, className, 'step-user-info')}>
    <div className="appointment-detail">
      <div className={classes.bold}>{i18n.getString(_TL_('Date and time'))}</div>
      <div className="info">
        <span>{bookingTimeInfo}</span>
        <DefaultButton
          text={i18n.getString(_TL_('Edit'))}
          onClick={onEditTime}
          styles={editButtonStyle}
        />
      </div>
    </div>
    <div className={classes.form}>
      <div className={classNames(classes.item, 'name')}>
        <TextField
          className="input-first-name"
          label={i18n.getString(_TL_('First name (optional)'))}
          value={name.firstName}
          onChange={(e, val) => onChangeName(e, val, 'firstName')}
          errorMessage={name.error.firstName}
        />
        <TextField
          className="input-last-name"
          label={i18n.getString(_TL_('Last name (optional)'))}
          value={name.lastName}
          onChange={(e, val) => onChangeName(e, val, 'lastName')}
          errorMessage={name.error.lastName}
        />
      </div>
      <div className={classes.item}>
        <TextField
          className="input-email"
          label={i18n.getString(_TL_('Email'))}
          value={email.value}
          onChange={onChangeEmail}
          errorMessage={email.error}
        />
      </div>
      <div className={classes.item}>
        <TextField
          className="input-phone"
          label={i18n.getString(_TL_('Phone'))}
          value={phoneNumber.value}
          onChange={onChangePhoneNumber}
          errorMessage={phoneNumber.error}
        />
      </div>
      <div className={classes.item}>
        <TextField
          className="input-message"
          label={i18n.getString(_TL_('Comments'))}
          value={extraMessage.value}
          onChange={onChangeExtraMessage}
          placeholder={i18n.getString(_TL_('Tell what service you\'re booking, what you\'d like them to do, and other details you think they should know.'))}
          resizable={false}
          styles={textAreaStyle}
          errorMessage={extraMessage.error}
          multiline
        />
      </div>
      {
        errorMessage && (
          <div className={classNames(classes.error, 'step-user-info-error')}>
            <span>*{i18n.getString(errorMessage)}</span>
          </div>
        )
      }
      {
        showWarning && (
        <MessageBar
          className="preview-warning-message"
          messageBarType={MessageBarType.warning}
          role="alert"
          isMultiline
        >
          <span>
            {i18n.getString(_TL_('Booking functionality is not supported in Preview mode. Please publish your website and try again.'))}
          </span>
        </MessageBar>
        )
      }
    </div>
  </div>
);

UnstyledBookingStepUserInfo.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  bookingTimeInfo: PropTypes.string.isRequired,
  onEditTime: PropTypes.func.isRequired,
  name: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  onChangeName: PropTypes.func.isRequired,
  email: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }).isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  phoneNumber: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }).isRequired,
  onChangePhoneNumber: PropTypes.func.isRequired,
  extraMessage: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }).isRequired,
  onChangeExtraMessage: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  showWarning: PropTypes.bool,
};

UnstyledBookingStepUserInfo.defaultProps = {
  className: '',
  errorMessage: '',
  showWarning: false,
};

export const BookingStepUserInfo = withDefaultStyles(
  UnstyledBookingStepUserInfo,
  getStyles
);
